export let productCenterHerculesViewEN = {
  title: "Hercules Cost-Effective Hardware-in-the-Loop \nSimulation Platform",
  subtitle: "Great task, little effort",
  intro: {
    title: "Hercules",
    content:
      "Hercules is a HiL simulation platform designed for the verification and validation of AI spatial agent controllers. The platform can simulate the hardware signals, bus node signals, power supply logic, process signals, and electrical fault states required by the controller under test, while simultaneously capturing and analyzing the controller's control signals to achieve closed-loop simulation testing.",
  },
  feature: {
    title: "Key Features of Hercules",
    list: [
      {
        icon: require("@/static/img/futureIcon2.svg"),
        h1: "High Scalability",
        h2: "The hardware system adopts a modular design, offering excellent expandability.",
      },
      {
        icon: require("@/static/img/futureIcon1.svg"),
        h1: "High-Precision Clock Synchronization",
        h2: "Provides high-precision hardware and software clock synchronization via PCIE bus.",
      },
      {
        icon: require("@/static/img/futureIcon4.svg"),
        h1: "High Cost-Effectiveness",
        h2: "Utilizes high-performance boards manufactured by leading international OEMs.",
      },
      {
        icon: require("@/static/img/futureIcon3.svg"),
        h1: "Efficient Management Dashboard",
        h2: "Enables real-time data acquisition, recording, monitoring, and configuration, improving usability and efficiency.",
      },
      {
        icon: require("@/static/img/futureIcon7.svg"),
        h1: "Diverse Interface Support",
        h2: "Supports CAN, LIN, automotive Ethernet, standard Ethernet communication, general I/O interface simulation, and LVDS.",
      },
      {
        icon: require("@/static/img/futureIcon5.svg"),
        h1: "Flexible Automated Testing",
        h2: "Allows integration of Js/Python scripts into automated test sequences to implement complex testing procedures.",
      },
      {
        icon: require("@/static/img/futureIcon6.svg"),
        h1: "Intuitive Interface Mapping",
        h2: "Variables in the system can be mapped to hardware interfaces within a tree topology structure.",
      },
    ],
  },
};
export let productCenterHerculesViewCN = {
  title: "Hercules（海格力斯） 高性价比硬件在环仿真平台",
  subtitle: "四两拨千斤，以小博大",
  intro: {
    title: "Hercules",
    content:
      "Hercules是一款专为AI空间智能代理控制器验证与确认设计的HiL仿真平台。该平台能够模拟待测控制器所需的车辆硬线信号、总线节点信号、供电逻辑与过程信号、电气故障等状态，同时采集与解析控制器控制信号，从而完成闭环仿真测试。",
  },
  feature: {
    title: "Hercules的特点",
    list: [
      {
        icon: require("@/static/img/futureIcon2.svg"),
        h1: "高拓展性",
        h2: "硬件系统基于模块化设计，具有较好的扩展性",
      },
      {
        icon: require("@/static/img/futureIcon1.svg"),
        h1: "高精度时钟同步",
        h2: "通过 PCIE 总线提供高精度软硬件时钟同步",
      },
      {
        icon: require("@/static/img/futureIcon4.svg"),
        h1: "高性价比",
        h2: "国际大厂代工的高性能板卡",
      },
      {
        icon: require("@/static/img/futureIcon3.svg"),
        h1: "高效的管理大屏",
        h2: "实现数据实时采集、记录、监控、配置，提高使用便捷性与效率",
      },
      {
        icon: require("@/static/img/futureIcon7.svg"),
        h1: "丰富的接口形式",
        h2: "支持CAN、LIN、车载以太网、以太网通讯以及通用I/O接口仿真，支持LVDS功能扩展",
      },
      {
        icon: require("@/static/img/futureIcon5.svg"),
        h1: "灵活的自动化测试",
        h2: "支持在自动化测试序列中嵌入Python脚本语言，以实现复杂的测试步骤",
      },
      {
        icon: require("@/static/img/futureIcon6.svg"),
        h1: "直观的接口映射匹配",
        h2: "在树状拓扑结构中可将系统中的变量与硬件接口进行映射匹配",
      },
    ],
  },
};
